import { CrudConfig, handleIPTypeChange } from '../../../../model/table';
import { useStores } from '../../../store';
import { Address, AddressGroup } from '../../../../dtos/version.dto';
import { AddressIPType, AddressType } from '../../../../utils/enums';
import addressService from '../../../../services/address.service';
import { MAX_ADDRESSES_LIMIT } from '../../../../utils/constants';

const addressesDataChangesHandler = (addressGroups: AddressGroup[]) => {
    return {
        set: (obj: any, prop: string, value: any) => {
            handleIPTypeChange(obj, prop, value);
            obj[prop] = value;
            return true;
        }
    };
};

export const useAddressesCrudConfig = (promiseFeedbackFactory: any): CrudConfig<Address> => {
    const { fwVersionStore } = useStores();

    return {
        createNewText: 'Add Address',
        displayInlineActions: !!fwVersionStore.isSelectedVersionEditable,
        disableEditReason: fwVersionStore.getDisableReason,
        newRecord: {
            displayName: '',
            type: AddressType.IPV4_NETMASK,
            ipType: AddressIPType.IP_NETMASK,
            value: '',
            description: '',
            associatedAddressGroupList: []
        },
        entityName: 'Address',
        rowLimit: MAX_ADDRESSES_LIMIT,
        saveCb: async (data: any) => {
            await fwVersionStore.genericCrudMethod(addressService.createAddress, [data]);
        },
        updateCb: async (updatedRecord: Address, originalRecord: Address) => {
            await fwVersionStore.genericCrudMethod(addressService.updateAddress, [updatedRecord, originalRecord.displayName]);

        },
        removeCb: async (data) => {
            await fwVersionStore.genericCrudMethod(addressService.deleteAddress, [data.displayName]);

        },
        dataChangesHandler: addressesDataChangesHandler(fwVersionStore.getAddressGroups),
    };
};